import './style.scss';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import ModalContainer from '../../components/modalContainer';
import CreateSchool from '../../components/adminSchools/createSchool';
import CreateAdvisory from '../../components/adminSchools/createAdvisory';
import CreateSocialControl from '../../components/adminSchools/createSocialControl';
import SchoolCardMini from '../../components/schoolsDinam/schoolCardMini';

import { constants } from '../../config/constants';
import {
  getMunicipalities,
  getUsers,
  getSchools,
  getExplorationsByFacilitator,
} from '../../API/apiService';

const COP_ADVISORY_TYPE_OPTIONS = [
  { name: 'Asesoría', id: 'ASESORIA' },
  { name: 'Comité Pedagógico', id: 'COMITE_PEDAGOGICO' },
  { name: 'Evento', id: 'EVENTO' },
  { name: 'Otro', id: 'OTRO' }
];

function RegisterSchoolsDinam() {
  const navigate = useNavigate();
  const userId = localStorage.getItem(constants.USER_ID);
  const userName = localStorage.getItem(constants.USERNAME);
  const userRole = localStorage.getItem(constants.ROLE);
  const normalizedUserRole = String(userRole || '').trim().toLowerCase();
  const isMediatorCop = normalizedUserRole === 'mediador cop';
  const isSocialControlMediator =
    normalizedUserRole === 'mediador control social';

  const [openModal, setOpenModal] = useState(false);
  const [municipalities, setMunicipalities] = useState([]);
  const [users, setUsers] = useState([]);
  const [schools, setSchools] = useState([]);

  function mapUsersResponse(list) {
    if (!Array.isArray(list)) return [];
    const usersMap = new Map();
    list.forEach((user) => {
      if (!user?.id) return;
      const normalizedName = String(user.full_name || user.username || '').trim();
      if (!normalizedName) return;
      usersMap.set(user.id, {
        id: user.id,
        name: normalizedName,
        roleName: user.role?.name,
        roleId: user.role?.id,
        active: user.active === undefined ? true : Boolean(user.active)
      });
    });
    return Array.from(usersMap.values());
  }

  async function getUsersInfo() {
    try {
      const u = await getUsers({ noCache: true });
      setUsers(mapUsersResponse(u));
    } catch (err) {
      console.error('Error loading users', err);
      setUsers([]);
    }
  }

  const advisoryType = COP_ADVISORY_TYPE_OPTIONS;
  const schoolType = [
    { name: 'INSTITUCION EDUCATIVA', id: 'IE' },
    { name: 'DIPLOMADO', id: 'DIPLOMADO' },
    { name: 'JAL', id: 'JAL' },
    { name: 'JAC', id: 'JAC' },
    { name: 'ORGANIZACIONES SOCIALES', id: 'OS' },
    { name: 'COLECTIVO', id: 'COLECTIVO' }
  ];

  async function getSchoolsInfo() {
    if (!userId || userId === 'null') return;

    const numericUserId = Number(userId);

    try {
      const schoolsResp = await getSchools(numericUserId);
      const expResp = await getExplorationsByFacilitator(numericUserId);

      const schoolsArr = Array.isArray(schoolsResp)
        ? schoolsResp
        : Array.isArray(schoolsResp?.data)
          ? schoolsResp.data
          : [];

      const explorationsArr = Array.isArray(expResp)
        ? expResp
        : Array.isArray(expResp?.data)
          ? expResp.data
          : [];

      const expBySchool = new Map();
      explorationsArr.forEach((exploration) => {
        expBySchool.set(Number(exploration.schoolId), exploration);
      });

      const merged = schoolsArr.map((school) => {
        const exploration = expBySchool.get(Number(school.id)) || null;
        return { ...school, exploration };
      });

      setSchools(merged);
    } catch (err) {
      console.error('Error loading schools/explorations', err);
      toast('Error cargando Proceso Formativo', { type: 'error' });
      setSchools([]);
    }
  }

  async function getBasicInfo() {
    try {
      const municipalitiesResponse = await getMunicipalities();
      if (municipalitiesResponse) setMunicipalities(municipalitiesResponse);

      await getUsersInfo();
      await getSchoolsInfo();
    } catch (err) {
      console.error('Error loading basic info', err);
    }
  }

  async function handleOpenCreateSchool() {
    const municipalitiesResponse = await getMunicipalities();
    if (municipalitiesResponse) setMunicipalities(municipalitiesResponse);
    await getUsersInfo();
    setOpenModal(true);
  }

  function goToExplorationEdit(school) {
    navigate(`/exploracion/${school.id}`, {
      state: { backTo: '/registrarEscuelas' }
    });
  }

  async function onSchoolActivated() {
    await getSchoolsInfo();
  }

  async function onCreateSchool(created) {
    if (created) {
      toast(
        isMediatorCop
          ? 'Asesoría creada exitosamente!'
          : isSocialControlMediator
            ? 'Actividad de Control Social creada exitosamente!'
            : 'Proceso Formativo creado exitosamente!',
        { type: 'success' }
      );
      setOpenModal(false);
      if (!isSocialControlMediator) {
        await getSchoolsInfo();
      }
    }
  }

  useEffect(() => {
    if (userId && userId !== 'null') {
      getBasicInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return (
    <>
      {openModal && (
        <ModalContainer>
          {isMediatorCop ? (
            <CreateAdvisory
              municipalities={municipalities}
              schoolType={advisoryType}
              setOpenModal={setOpenModal}
              users={users}
              created={onCreateSchool}
              defaultProgramScope={
                normalizedUserRole.includes('ndn') ||
                normalizedUserRole.includes('nada de nervios')
                  ? 'NDN'
                  : 'PF'
              }
              currentMediatorId={userId}
              currentMediatorName={userName}
            />
          ) : isSocialControlMediator ? (
            <CreateSocialControl
              setOpenModal={setOpenModal}
              created={onCreateSchool}
            />
          ) : (
            <CreateSchool
              municipalities={municipalities}
              schoolType={schoolType}
              setOpenModal={setOpenModal}
              users={users}
              created={onCreateSchool}
            />
          )}
        </ModalContainer>
      )}

      <section className='schools schools--register'>
        <div className='schools__content content'>
          <div className='content__welcome'>
            <div className='schools-header'>
              <div className='schools-header__text'>
                <h2 className='schools-header__title'>
                  {isMediatorCop
                    ? 'Quieres agregar una Asesoría a la que le harás una concertación?'
                    : isSocialControlMediator
                      ? '¿Quieres agregar una actividad de Control Social?'
                      : '¿Quieres agregar un Proceso Formativo / Entidad Aliada?'}
                </h2>
                <p className='schools-header__subtitle'>
                  {isMediatorCop
                    ? 'Selecciona una Asesoría para editar o crear la evidencia de concertación.'
                    : isSocialControlMediator
                      ? 'Selecciona una actividad para editar o crear su evidencia.'
                      : 'Selecciona un Proceso Formativo para editar o crear la evidencia de concertacion.'}
                </p>
              </div>

              <button
                type='button'
                className='schools-header__action'
                onClick={handleOpenCreateSchool}
              >
                <span className='schools-header__icon' aria-hidden='true'>+</span>
                <span>
                  {isMediatorCop
                    ? 'Agregar Asesoría'
                    : isSocialControlMediator
                      ? 'Agregar actividad'
                      : 'Agregar Proceso Formativo'}
                </span>
              </button>
            </div>
          </div>

          <div className='content__wrapper'>
            {schools?.length > 0 ? (
              schools.map((school) => (
                <SchoolCardMini
                  key={school.id}
                  school={school}
                  onEditEvidence={goToExplorationEdit}
                  onSchoolActivated={onSchoolActivated}
                  isMediatorCop={isMediatorCop}
                  isSocialControlMediator={isSocialControlMediator}
                />
              ))
            ) : (
              <p style={{ padding: '1rem' }}>
                {isMediatorCop
                  ? 'Aún no tienes Asesorías para mostrar.'
                  : isSocialControlMediator
                    ? 'Aún no tienes actividades de Control Social para mostrar.'
                    : 'Aun no tienes Proceso Formativo para mostrar.'}
              </p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default RegisterSchoolsDinam;
